import { GALLERY_JOBS } from "@/data/site";

export default function Gallery() {
  return (
    <section id="gallery" className="bg-[#0f172a] text-white py-24 border-b border-slate-800">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6">
          <div>
            <span className="text-xs font-bold uppercase tracking-widest text-blue-400 block mb-2">Verified Field Evidence</span>
            <h2 className="display-font text-4xl sm:text-5xl uppercase tracking-tight text-white">
              Before &amp; After Restoration
            </h2>
          </div>
          <div className="text-xs uppercase tracking-widest text-slate-400 font-mono">
            <span>Actual Site Work • Mumbai Projects</span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {GALLERY_JOBS.map((job, i) => (
            <div
              key={job.tag}
              data-testid={`gallery-job-${i + 1}`}
              className="bg-[#1e293b] border border-slate-700 rounded-lg p-5 flex flex-col justify-between"
            >
              <div>
                <div className="flex justify-between items-center mb-4">
                  <span className="mono-font text-xs font-bold bg-[#1e3a8a] text-white px-2.5 py-1 rounded">{job.tag}</span>
                  <span className="text-[11px] text-slate-400 font-semibold uppercase">{job.place}</span>
                </div>
                <figure className="relative aspect-[3/4] rounded overflow-hidden mb-4">
                  <img
                    src={job.img}
                    alt={`${job.title} — before and after photos from an actual Anas Enterprises site`}
                    className="absolute inset-0 w-full h-full object-cover"
                    loading="lazy"
                  />
                  <div className="absolute bottom-3 left-3 flex gap-2">
                    <span className="text-[10px] uppercase font-bold text-white bg-red-600/90 px-1.5 py-0.5 rounded">Before</span>
                    <span className="text-[10px] uppercase font-bold text-white bg-emerald-600/90 px-1.5 py-0.5 rounded">After</span>
                  </div>
                </figure>
              </div>
              <div>
                <h4 className="font-bold text-sm text-white uppercase tracking-wider mb-1">{job.title}</h4>
                <p className="text-xs text-slate-400">{job.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
